import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginPost } from "../repositories/userRepo";

const initialState = {
  response: {},
  loading: false,
  error: false,
  errorMsg: "",
};
export const login = createAsyncThunk(
  "login",
  async (email, password, thunkAPI) => {
    const response = await loginPost(email, password);
    return response;
  }
);
export const loginSlice = createSlice({
  name: "login",
  initialState,
  extraReducers: {
    [login.pending]: (state) => {
      state.loading = true;
    },
    [login.fulfilled]: (state, action) => {
      state.loading = false;

      state.response = action.payload;
      console.log(action.payload);
    },
    [login.rejected]: (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMsg = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default loginSlice.reducer;
